import React from 'react';

import { Company, CompanyZone, CompanyZoneCallCenter } from '_lib/api/apiTypes.shim';
import { Typography } from '_lib/components/Typography/Typography';

import { HeaderBox, HeaderBoxProps } from '_lib/featureComponents/HeaderBox/HeaderBox';
import { TextBlockTypography } from '_lib/featureComponents/TextBoxTypography/TextBoxTypography';

export const zonedTooltipText = (company: Pick<Company, 'isZoned'>) =>
  company.isZoned ? 'Info is specific to the selected zone' : null;

export const zonedCompanyWithoutZoneSelectedWarning = (company: Pick<Company, 'isZoned'>, zone?: CompanyZone | null) =>
  company.isZoned && !zone?.id ? <Typography color='error' text='Select zone to see info' /> : null;

interface ZoneOverrideTextBlockProps extends HeaderBoxProps {
  company: Pick<Company, 'isZoned' | 'callCenter'>;
  zone?: CompanyZone | null;
  zoneCallCenterProp: keyof CompanyZoneCallCenter;
}

export const ZoneOverrideTextBlock = (props: ZoneOverrideTextBlockProps) => {
  const { headerText, zone, company, zoneCallCenterProp, ...restOfProps } = props;
  const tooltipText = zonedTooltipText(company);
  const companyWithoutZoneSelectedWarning = zonedCompanyWithoutZoneSelectedWarning(company, zone);

  const text = company.isZoned ? zone?.callCenter[zoneCallCenterProp] : company.callCenter[zoneCallCenterProp];
  return (
    <HeaderBox headerText={headerText} infoIconText={tooltipText || props.infoIconText} {...restOfProps}>
      {companyWithoutZoneSelectedWarning || <TextBlockTypography text={text} />}
    </HeaderBox>
  );
};
